module.exports = __webpack_public_path__ + "static/media/phone-outline.d5613857.svg";